// src/pages/Politicas.jsx
import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../politicas.css";

const Politicas = () => {
  return (
    <>
      <Navbar />

      <div className="politicas-container">
        <div className="politicas-card">
          <h2>POLÍTICAS GENERALES</h2>

          {/* STOCK */}
          <section className="politicas-section">
            <h3>Inventario</h3>
            <p>
              Los productos publicados se encuentran disponibles
              para encargar. Para consultar acerca de stock disponible para entrega inmediata, preguntanos al WhatsApp.
            </p>
            <p>
              El envío se realiza una vez acreditado el pago correspondiente.
            </p>
          </section>

          {/* ENCARGOS */}
          <section className="politicas-section">
            <h3>Productos por encargo</h3>
            <p>
              La mayoría de los productos se trabajan bajo modalidad encargo.
              Para hacer un encargo se requiere un anticipo mínimo del 20%.
            </p>
            <p>
              Una vez confirmado el pedido con el proveedor, el anticipo no es reembolsable.
            </p>
            <p>
              Los tiempos de llegada son <b>estimados</b> y pueden variar por cuestiones logísticas,
              aduaneras o disponibilidad del fabricante.
            </p>
          </section>

          {/* CAMBIOS */}
          <section className="politicas-section">
            <h3>Cambios y devoluciones</h3>
            <ul>
              <li>
                Solo se aceptan cambios de productos en stock.
              </li>
              <li>
                El plazo máximo para solicitar un cambio es de 7 días desde recibido el producto.
              </li>
              <li>
                El producto debe encontrarse sin uso, con etiquetas y empaque original.
              </li>
              <li>
                Los costos de envío por cambio corren por cuenta del cliente.
              </li>
              <li>
                Los productos por encargo no tienen cambio ni devolución, sin excepción.
              </li>
            </ul>
          </section>

          {/* ENVÍOS */}
          <section className="politicas-section">
            <h3>Envíos</h3>
            <p>
              Realizamos envíos nacionales e internacionales mediante Correo Argentino u operador logístico acordado.
            </p>
            <p>
              El costo depende del peso, volumen y destino.
            </p>
            <p>
              Una vez despachado el producto, Lifting Store no se responsabiliza por demoras
              propias del servicio de transporte.
            </p>
          </section>

          {/* PAGOS */}
          <section className="politicas-section">
            <h3>Medios de pago</h3>
            <p>
              Aceptamos efectivo y transferencia en:
            </p>
            <ul>
              <li>Dólares estadounidenses (USD)</li>
              <li>USDT</li>
              <li>Pesos argentinos</li>
            </ul>
            <p>
              Las operaciones en pesos argentinos se cotizan al valor del dólar blue vigente
              al momento de la acreditación.
            </p>
          </section>

          {/* GARANTÍA */}
          <section className="politicas-section">
            <h3>Garantía</h3>
            <p>
              Los productos cuentan con garantía únicamente por fallas de fabricación.
            </p>
            <p>
              No se consideran fallas los daños ocasionados por uso indebido,
              desgaste natural o manipulación incorrecta.
            </p>
          </section>

          {/* RESPONSABILIDAD */}
          <section className="politicas-section">
            <h3>Responsabilidad</h3>
            <p>
              Lifting Store actúa como intermediario comercial en productos importados por encargo.
            </p>
            <p>
              Nos comprometemos a gestionar cada pedido con transparencia y comunicación constante.
            </p>
          </section>

          {/* SOPORTE */}
          <section className="politicas-section">
            <h3>Soporte</h3>
            <p>
              Atención al cliente:
              <br />
              Lunes a Sábado: 9:00 a 21:00 hs
              <br />
              Domingos y feriados: 11:00 a 18:00 hs
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Politicas;
